import { observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { ManageNocServer } from './ManageNocServer';
import { NocServersList } from './NocServersList';

export interface INocServersViewProps extends RouteComponentProps<undefined> {}

@observer
export class NocServersView extends React.Component<INocServersViewProps> {
    public render() {
        return (
            <>
                <Route path="/noc-servers" exact component={NocServersList} />
                <Route path="/noc-servers/:name" exact component={ManageNocServer} />
            </>
        );
    }
}
